import { Navigate, useLocation } from "react-router-dom";

/**
 * Gate for pages that need an account.
 *
 * It used to redirect with `<Navigate to="/login" />` and nothing else, which
 * lost the destination. A shopper who added a garment and tapped View cart
 * was thrown to a login form with no explanation, and after signing in landed
 * on the homepage -- their bag one more click away, with no sign the item had
 * survived. That is the worst moment on the site arriving immediately after
 * the best one.
 *
 * The attempted location now travels with the redirect so Login can return
 * them to it. `replace` keeps the gate out of history: pressing Back from the
 * login screen goes to the page they came from, not into a redirect loop.
 */
function PrivateRoutes({ children }) {
  const token = localStorage.getItem("userToken");
  const location = useLocation();

  return token ? children : (
    <Navigate to="/login" replace state={{ from: location }} />
  );
}

export default PrivateRoutes;
